/**
 * @generated SignedSource<<aebb341e2646333667a15d8b73ec57bd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GeoHeader_geo$data = {
  readonly iso3166: string | null;
  readonly name: string;
  readonly " $fragmentType": "GeoHeader_geo";
};
export type GeoHeader_geo$key = {
  readonly " $data"?: GeoHeader_geo$data;
  readonly " $fragmentSpreads": FragmentRefs<"GeoHeader_geo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GeoHeader_geo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "iso3166",
      "storageKey": null
    }
  ],
  "type": "State",
  "abstractKey": null
};

(node as any).hash = "ee16653ff3629bfdda4977f164d3924f";

export default node;
